import { gql } from 'src/__generated__';

export const UPDATE_LICENCE = gql(`
  mutation ApplyUpdateLicence($input: UpdateLicenceInput!) {
    updateLicence(input: $input) {
      viewer {
        _id
        licences {
          ...licence
        }
      }
    }
  }
`);
